import React from "react";
import { noop } from "utils/General";
import { Div } from "components/Base";
import PageLocation from "./PageLocation";
import MutedPagination from "./MutedPagination";

const SlimPaginationBar = ({
  pagination = {},
  rowsText = "rows",
  onPageChange = noop,
  showLabel = true,
  ...styleProps
}) => (
  <Div
    bg="white"
    display="row.space-between.center"
    width={1}
    pt={2}
    {...styleProps}
  >
    {showLabel ? (
      <PageLocation
        pageSize={pagination.pageSize}
        pages={pagination.pages}
        page={pagination.page}
        total={pagination.total}
        rowsText={rowsText}
      />
    ) : (
      ""
    )}
    <MutedPagination
      canPrevious={pagination.page > 0}
      canNext={pagination.page < pagination.pages - 1}
      page={pagination.page}
      pages={pagination.pages}
      onPageChange={onPageChange}
    />
  </Div>
);

export default SlimPaginationBar;
